import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isLoggedIn } from "../hooks/useAuth";
import Navbar from "./Navbar";

/** Yalnız login olmuş müştəri üçün (məs. Kuponlarım) */
const ProtectedLayout = () => {
  const location = useLocation();

  if (!isLoggedIn()) {
    sessionStorage.setItem("quizzo_redirect", location.pathname);
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-shell flex flex-col bg-gradient-to-br from-indigo-600 via-purple-600 to-fuchsia-600">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default ProtectedLayout;
